import type { UserData } from '../context/UserContext'
import type { MembershipSummary } from '../pages/SelectOrganisation'

// "Sample state": the user's active organisation is their personal sample organisation.
export const isSampleState = (userData?: Pick<UserData, 'access'> | null) =>
	userData?.access?.fictitiousKind === 'sample'

// Sidebar sections offered in sample state; everything else (insights, supplier invitations, public
// report search, reports, data hub) is hidden. Bottom items (help, settings) always stay. UX only.
const SAMPLE_MENU_PATH_PREFIXES = ['/dashboard', '/purchases']

export const isSampleMenuPath = (path: string) =>
	SAMPLE_MENU_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix + '/'))

// #869 Decision 9: memberships that stay visible when the user has chosen to hide sample/demo/
// training organisations - every real membership, plus any fictitious one that is currently
// locked. A locked fictitious org (e.g. auto-locked after losing its last other member, see
// lockOrganisationIfEmpty()) is actionable - the member can still open the picker and request an
// unlock - and must not silently vanish just because it also happens to be fictitious. An
// *unlocked* fictitious org keeps the existing hide-by-preference behaviour.
export const visibleMembershipsWhenHidingFictitious = (memberships: MembershipSummary[]) =>
	memberships.filter((membership) => !membership.fictitiousKind || membership.companyLocked)

// The user has hidden sample/demo/training organisations and has no real (or locked-and-actionable)
// one, so there is nothing to show.
export const hasNoVisibleOrganisation = (
	userData?: Pick<UserData, 'memberships' | 'showFictitiousOrganisations'> | null
) => {
	const memberships = userData?.memberships ?? []
	return (
		userData?.showFictitiousOrganisations === false &&
		memberships.length > 0 &&
		visibleMembershipsWhenHidingFictitious(memberships).length === 0
	)
}
